module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAA1CAYAAAA3Q3kVAAAAAXNSR0IArs4c6QAAAJBJREFUaEPt2kEKgCAUBNC8gd7/kB6hINBNtHKChNc+k9f8yUWl1noeG1xlu4323n/p2lq79zVFbXTxPRFdBHzcTpToKHz1tJgFw7QIqJ7SgESJDgH1lM4CUaJOT6EMGKYQ5FyGKFH1FMqAYQpBqqc0JFGi6imdAaJEnZ5CGTBMIUjf+jTku+hnTwotvM2vGheFh9Hx9quABwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page/crop/four-to-five.png
// module id = 2fUM
// module chunks = 3